import { render, staticRenderFns } from "./AwardedBlock.vue?vue&type=template&id=daab7c3e&scoped=true&"
import script from "./AwardedBlock.vue?vue&type=script&lang=js&"
export * from "./AwardedBlock.vue?vue&type=script&lang=js&"
import style0 from "./AwardedBlock.vue?vue&type=style&index=0&id=daab7c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daab7c3e",
  null
  
)

export default component.exports